import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-play_video",
  "use": "icon-play_video-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-play_video\"><defs><style type=\"text/css\"></style></defs><path d=\"M695.466667 494.933333c-19.2-12.8-249.6-164.266667-260.266667-170.666666-8.533333-6.4-21.333333-2.133333-25.6 6.4-2.133333 4.266667-2.133333 8.533333-2.133333 12.8v341.333333c-2.133333 10.666667 6.4 19.2 17.066666 21.333333 4.266667 0 8.533333 0 10.666667-2.133333 17.066667-10.666667 247.466667-162.133333 262.4-170.666667 10.666667-6.4 12.8-21.333333 4.266667-32-4.266667-4.266667-4.266667-6.4-6.4-6.4z\" p-id=\"2891\" /><path d=\"M512 0c-283.733333 0-512 228.266667-512 512s228.266667 512 512 512 512-228.266667 512-512-228.266667-512-512-512z m0 981.333333c-260.266667 0-469.333333-209.066667-469.333333-469.333333s209.066667-469.333333 469.333333-469.333333 469.333333 209.066667 469.333333 469.333333-209.066667 469.333333-469.333333 469.333333z\" p-id=\"2892\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/play_video.svg
// module id = 9KuX
// module chunks = 31